import Base from '../../common/Base';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ChatPopup from '../../common/ChatPopup';
import {
  Nav,
  Row,
  Col,
  Container,
  Card,
  CardHeader,
  Button,
  Form,
  CardBody,
  Table,
  FormCheck,
  Alert,
  CardFooter,
  Breadcrumb,
  InputGroup,
  Tabs,
  Tab
} from 'react-bootstrap';
import { getLitigations } from '../../../slices/forms/litigation';

const LitigationList = () => {
  const { litigationData, loading, error } = useSelector((state) => state.litigation);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLitigations({}));
  }, [dispatch]);

  return (
    <Base header="litigations" headerTitle={'Litigations'}>
      <Container fluid className="px-2 px-md-3">
        <Card>
          <Card.Body className="p-2 p-md-3">
            <Row>
              <Col xs={12}>
                <Card>
                  <Tabs
                    defaultActiveKey="litigationList"
                    id="litigation-management-tabs"
                    className="mb-3">
                    <Tab eventKey="litigationList" title="Litigation List">
                      <CardBody className="p-2 p-md-3">
                        <Col xs={12}>
                          <div className="table-responsive">
                            <Table
                              responsive
                              bordered
                              striped
                              id="litigation-list-table"
                              className="mt-2 mt-md-4">
                              <thead>
                                <tr>
                                  <th scope="col" className="text-nowrap">SL.No:</th>
                                  <th scope="col" className="text-nowrap">Particulars</th>
                                  <th scope="col" className="text-nowrap">Period</th>
                                  <th scope="col" className="text-nowrap">Current Status</th>
                                  <th scope="col" className="text-nowrap">Final Status</th>
                                  <th scope="col" className="text-nowrap">Notices and Orders</th>
                                  <th scope="col" className="text-nowrap">Created Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {litigationData.length ? (
                                  litigationData.map((litigation, index) => (
                                    <tr key={litigation.id}>
                                      <td className="text-nowrap">{index + 1}</td>
                                      <td className="text-break">{litigation.particular}</td>
                                      <td className="text-nowrap">{litigation.period}</td>
                                      <td className="text-break">{litigation.current_status}</td>
                                      <td className="text-break">{litigation.final_status}</td>
                                      <td className="text-center">
                                        {litigation.notices_and_orders ? (
                                          <a
                                            href={litigation.notices_and_orders}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className=" btn-link"
                                          >
                                            View File
                                          </a>
                                        ) : (
                                          <label className=" btn-link text-decoration-none">
                                            No File
                                          </label>
                                        )}
                                      </td>
                                      <td className="text-nowrap">{litigation.created_date.split('T')[0]}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="6" className="text-center">
                                      No Litigation Found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </CardBody>
                    </Tab>
                  </Tabs>
                </Card>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <ChatPopup chat_type="LITIGATION" />
    </Base>
  );
};

export default LitigationList;